import { GetAddressType as ApiAddressType } from 'src/api/generated/touring/types';
import { AddressType } from '../../types';

export const mapAddress = (address: ApiAddressType): AddressType => {
  return {
    street: address.street,
    addition: address.addition,
    zip: address.zip,
    city: address.city,
    country: address.country,
    cityEnglish: address.cityEnglish,
    state: address.state,
  };
};
